import { daysUntil } from './jobCardUtils';

/**
 * Thin urgency bar pinned to the bottom edge of a card. Fill shrinks and reddens
 * as the deadline nears (over a 30-day window). Renders nothing without a deadline.
 */
export default function DeadlineBar({ deadline }) {
  const days = daysUntil(deadline);
  if (days == null) return null;

  const WINDOW = 30;
  const pct = Math.max(0, Math.min(1, days / WINDOW)) * 100;

  let color = 'var(--tandm-success-fg)';
  if (days < 0) color = 'var(--tandm-danger-fg)';
  else if (days <= 3) color = 'var(--tandm-danger-fg)';
  else if (days <= 7) color = 'var(--tandm-warning-fg)';

  return (
    <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0, height: 3, background: 'var(--tandm-line-soft)', zIndex: 3 }}>
      <div
        style={{
          height: '100%',
          width: `${days < 0 ? 100 : pct}%`,
          background: color,
          borderRadius: '0 2px 2px 0',
          transition: 'width 0.5s var(--tandm-ease)',
        }}
      />
    </div>
  );
}
